import React from 'react';

import RichTextEditorContent from '../../RichTextEditor/components/RichTextEditorContent';

import styles from './CommentRichTextEditor.module.scss';

const commentClassNames = {
  container: styles.commentEditorContainer,
  paragraph: styles.paragraph,
  citation: styles.citation,
};

const CommentRichTextEditor = ({
  setState,
  state,
  contentEditable,
}) => {
  return (
    <RichTextEditorContent
      state={state}
      setState={setState}
      contentEditable={contentEditable}
      classNames={commentClassNames}
    />
  );
};

export default CommentRichTextEditor;
